import { RequestServiceDescription } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';
import {
  hasHtmlInjectionTags,
  replaceTokensInString
} from '@cat-ecom/common/utils/stringUtils';
import { HTML_SPECIAL_CHAR_ERROR } from '@cat-ecom/common/utils/constants';
import styles from '../request-equipment-service.module.scss';

const Descriptionwrapper = () => {
  const t = useTranslations();
  return (
    <div className="pb-md-4">
      <div className="col-12 px-3">
        <div className="mt-4">
          <RequestServiceDescription
            rows={2}
            label={t('PT_TECHNICAL_SPECIFICATIONS')}
            maxlength={500}
            placeholder={t('REQUEST_SERVICE_DESCRIPTION')}
            classname={styles['request-service__description']}
            name="requestDescription"
            rules={{
              required: {
                value: true,
                message: t('EMPTY_REQUEST_SERVICE')
              },
              validate: {
                validateInputSanity: (value) => {
                  return hasHtmlInjectionTags(
                    value,
                    replaceTokensInString(
                      t('ADD_INV_CHAR_NEW_FIELD_WARNING', {
                        1: HTML_SPECIAL_CHAR_ERROR
                      })
                    )
                  );
                }
              }
            }}
            fieldId="textarea-field-1"
            size="md"
            data-testid="request_service_description"
          />
        </div>
      </div>
    </div>
  );
};

export default Descriptionwrapper;
